module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"labelA":"Arbeids-<br>hukommelse","labelB":"Kreativ<br>hukommelse"},"en":{"labelA":"Working<br>Memory","labelB":"Creative<br>Memory"}}')
  delete Component.options._Ctor
}
